import {DataTableColumn} from "mantine-datatable";
import {Invoice} from "../types.ts";
import {Text} from '@mantine/core';
import {Link} from 'react-router-dom';

export const useTableColumns = (context: 'customer' | 'reports' = 'reports') => {

    const columns: DataTableColumn<Invoice>[] = [
        {
            accessor: 'id',
            title: 'Invoice ID',
            render: (record: Invoice) => (
                <Link to={`/customers/${record.customerId}/invoices/${record.id}`} style={{ textDecoration: 'none' }}>
                    <Text c="blue" style={{ cursor: 'pointer' }}>
                        {record.id}
                    </Text>
                </Link>
            )
        },
        ...(context === 'reports' ? [{
            accessor: 'customer',
            title: 'Customer',
            render: (record: Invoice) => (
                <Link to={`/customers/${record.customerId}`} style={{ textDecoration: 'none' }}>
                    <Text c="blue" style={{ cursor: 'pointer' }}>
                        {record.customer ? record.customer.name : record.customerId}
                    </Text>
                </Link>
            )
        }] : []),
        {
            accessor: 'created',
            title: 'Created',
            render: (record: Invoice) => (
                <Text size="sm">
                    {record.created ? new Date(record.created).toLocaleDateString() : '-'}
                </Text>
            )
        },
    ];

    return {
        columns,
    }
}